import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServicesOverview from './components/ServicesOverview';
import ProjectGallery from './components/ProjectGallery';
import CustomerReviews from './components/CustomerReviews';
import ContactCTA from './components/ContactCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <ServicesOverview />
        <ProjectGallery />
        <CustomerReviews />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}